import React, { useEffect, useRef } from "react";
import "../../assets/css/Testimonial.css";

const ActiveTestimonial = ({ testimonial }) => {
    const testimonialRef = useRef(null);

    useEffect(() => {
        const card = testimonialRef.current;
        if (card) {
            const handleMouseMove = (event) => {
                const cardRect = card.getBoundingClientRect();
                const cardWidth = cardRect.width;
                const cardHeight = cardRect.height;
                const centerX = cardRect.left + cardWidth / 2;
                const centerY = cardRect.top + cardHeight / 2;

                const tiltX = ((event.clientY - centerY) / (cardHeight / 2)) * -5;
                const tiltY = ((event.clientX - centerX) / (cardWidth / 2)) * -5;

                card.style.transform = `perspective(1400px) rotateX(${tiltX}deg) rotateY(${tiltY}deg) scale(1.04)`;
            };

            const handleMouseLeave = () => {
                card.style.transform = `perspective(1400px) scale(1)`;
            };

            card.addEventListener("mousemove", handleMouseMove);
            card.addEventListener("mouseleave", handleMouseLeave);

            return () => {
                card.removeEventListener("mousemove", handleMouseMove);
                card.removeEventListener("mouseleave", handleMouseLeave);
            };
        }
    }, []);

    return (
        <>
            <h1 className="display-4 fw-bold text-center m-0 mt-5">What our Clients Say</h1>
            <div className="row mb-5">
                <div className="col-12 mt-4">
                    <div
                        ref={testimonialRef}
                        className="p-5 testimonial active-testimonial d-flex align-items-center"
                    >
                        <div className="me-4">
                            <img src={`https://api.glyphqai.com/uploads/testimonals/${testimonial.image}`} alt="testimonial-image" className="client-img" />
                        </div>
                        <div className="testimonial-content">
                            <h3 className="display-5 fw-bold text-start">{testimonial.title}</h3>
                            <p className="small-d fs-3">{testimonial.role}</p>
                            <p className="small fs-5 mt-2">{testimonial.desc}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ActiveTestimonial;

